//
//
//
//
//
//
//
//
//

/**
 * mt-badge
 * @module components/badge
 * @desc 徽章
 * @param {string} [type=primary] 组件样式，可选 primary, error, success, warning
 * @param {string} [color] - 传入颜色值
 * @param {string} [size=normal] - 尺寸，接受 normal, small, large
 *
 * @example
 * <mt-badge color="error">错误</mt-badge>
 * <mt-badge color="#333">30</mt-badge>
 */

/**
 * @name Badge
 * @tagName mt-badge
 * @desc 徽章
 * @wrapClassName mint-badge
 * @display inline
 * @noteType component
 * @html
 * <mt-badge color="#333">{{text}}</mt-badge>
 */
export default {
  name: 'mt-badge',

    /**
     * @noteType prop
     * @field text
     * @desc 内容
     * @type input
     * @value 30
     */
  props: {
    fontColor: String,
    fontSize: String,
    padding: String,
    radius: String,
    bColor: String,
    /**
     * @noteType prop
     * @field color
     * @desc 颜色值
     * @type input
     * @placeholder #333
     */
    color: String,
    /**
     * @noteType prop
     * @field type
     * @desc 样式类型
     * @type select
     * @value primary
     * @option
     [{
       "text": "default",
        "value": "default"
      },{
        "text": "primary",
        "value": "primary"
      },{
        "text": "danger",
        "value": "danger"
      },{
        "text": "warning",
        "value": "warning"
      }]
      */
    type: {
      type: String,
      default: 'primary'
    },
    /**
     * @noteType prop
     * @field size
     * @desc 文字大小
     * @type select
     * @value small
     * @option
     [{
       "text": "正常",
        "value": "normal"
      },{
        "text": "小",
        "value": "small"
      },{
        "text": "大",
        "value": "large"
      }]
      */
    size: {
      type: String,
      default: 'normal'
    }
  }
};

/**
 * @noteType external
 * @content
 {
    "bindField":"text",
    "textField": {
        "field": "text",
        "className": "mint-badge"
      }
 }
 */



// WEBPACK FOOTER //
// ./packages/badge/src/badge.vue